var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "d-flex align-center gc-2 py-1 px-2 rounded special--text bg-special cursor-pointer",
      attrs: { "data-qa": "lpu_loyalty_program_plate" },
      on: {
        click: function ($event) {
          return _setup.emit("click")
        },
      },
    },
    [
      _c("span", {
        staticClass:
          "ui-icon-dzen ui-icon-fz-medium special--text flex-shrink-0",
      }),
      _vm._v(" "),
      _c("span", { staticClass: "text-body-2" }, [
        _vm._v(_vm._s(_setup.t("Программа лояльности", _setup.options))),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }